import classNames from 'classnames';
import { LegacyRef, forwardRef } from 'react';

interface NumberInputProps {
  id: string;
  label: string;
  description?: string;
  placeholder?: string;
  disabled?: boolean;
  error?: string;
}

const NumberInput = forwardRef(
  (props: NumberInputProps, ref: LegacyRef<HTMLInputElement>) => {
    const { id, label, description, disabled = false, error } = props;
    return (
      <div
        className={classNames(
          `xpl-input w-full flex flex-col font-sans text-left font-normal leading-normal text-base mb-5`,
          { '!mb-[2px]': error },
        )}
      >
        <label
          htmlFor={id}
          className='leading-normal text-sm font-medium text-dark-header'
        >
          {label}
        </label>
        {!!description && (
          <p className='text-xs leading-4 text-gray-500'>{description}</p>
        )}
        <div className='w-full flex flex-row items-center'>
          <div
            className={classNames(
              `xpl-input-wrapper mt-2 flex-1 items-center border border-solid rounded-md border-gray-300 bg-white w-full h-[44px] transition-colors duration-300 ease-in-out mb-[10px]`,
              {
                'bg-gray-100': disabled,
                'mb-0': error,
              },
            )}
          >
            <input
              ref={ref}
              disabled={disabled}
              type='number'
              className='w-full pl-0 text-gray-700 appearance-none focus:outline-none focus:ring-0 number-input'
              {...props}
              data-test-id={id}
            />
          </div>
          <p className='pl-2  leading-5 text-left text-black'>
            Pending reservation
          </p>
        </div>
        {error && <p className='text-xs leading-4 text-red-500'>{error}</p>}
      </div>
    );
  },
);

export default NumberInput;
